export type * from "./workflow-types";
export type { WorkflowEnginePin, OwnerWorkflowSettings } from "./types";
export type { FormContactView, ConfirmFormCustomerInput } from "./types";
// Live data client for the app — the real core-api over /api (same-origin, cookie session).
import type { CockpitClient } from "./client";
import { HttpCockpitClient, ApiError } from "./http-client";
import { withReadCache } from "./read-cache";

export const cockpit: CockpitClient = withReadCache(new HttpCockpitClient());

export { ApiError };
export { claimPrefetchedRequest, prefetchRequest } from "./request-prefetch";
export {
  getTenantContext,
  setTenantContext,
  withTenantContext,
  withTenantContextInHtml,
} from "./http-client";
export {
  CONVERSATION_ATTENTION_REASONS,
  FILED_MESSAGE_TRASH_CONFLICT,
  REQUEST_DONE_UNDO_CONFLICT,
  REQUEST_IN_TRASH,
  REQUEST_TRASH_CONFLICT,
} from "./types";
export type { CockpitClient } from "./client";
export type {
  AccountProfile, AttachmentRejection, AttachmentView, BusinessLogo,
  ConversationAttentionReason, ConversationListItem, ConversationListOptions, ConversationListPage, ConversationScope,
  ConversationSort,
  AppConfigInfo, HostEnvironmentInfo, Assignee, AssigneeRef, AssigneeSetResult, AuditEvent, ConsoleEventHandlers, ConsoleLiveEvent, DecisionExplanationView, DecisionStateView, DecisionView, DeliveryResolutionResult, DeliveryView, HamburgCutoffChangeView, HamburgCutoffView,
  CustomerFieldSource, CustomerForRequest, CustomerProfileField, CustomerSuggestion,
  CustomerUpdateInput, CustomerView,
  DraftAttachmentCancellationResult, DraftAttachmentMutationResult, DraftContinuationStatus, DraftResult, DraftView, OutboundDraftAttachmentView, EventSummary, Fact, Flags, MessageView, OverrideFactResult, OwnerTenantReadiness, PositionItem, PositionOccasion, PositionProposalOptions, PositionResolutionCode, PositionResolutionView, PositionStaffingFormat, PositionsView, RecomputeDecisionResult,
  OverviewMetrics, OverviewMetricsQuery, OverviewPeriod,
  PresenceMember, PresenceState, PresenceView,
  PreviousRequestSummary, PreviousRequestsView, CustomerMailItem, CustomerMailView, ReplyAcknowledgementResult, RequestActivityPage, RequestDetail,
  RequestListItem, ThreadTargetPage, RequestStatus, ResponsePlanView, ReviewState, Role,
  SendResult, SendState, ApproveAndSendCommand,
  NeoMailboxAvailability, NeoMailboxChangeResult, NeoMailboxOffer, NeoMailboxProvisionResult,
  PlatformMailboxCategory, PlatformMailboxSecret, PlatformMailboxView,
  PlatformMailDomainKind, PlatformMailDomains,
  MailDomainCheckOutcome, MailDomainCheckResult, MailDomainRecord,
  MailDomainSending, MailDomainSendingState, MailDomainState, MailDomainView,
  ForwardedOriginStatus, TrustedForwarderView,
  TenantNeoMailboxView, ReceivingAddressKind, ReceivingAddressRoute,
  TenantInvitation, IssuedInvitation, InvitationPreview,
  AcceptInvitationInput,
  StaffInvitation, IssuedStaffInvitation, StaffInvitationPreview,
  SetupState,
  SessionUser, TenantLifecycleResult, TenantMailboxCheckResult, TenantMailboxInput, TenantMailboxRow,
  TenantRow, TenantSendState, TenantStatus, TenantUsage,
  AnalysisRetryResult, AnalysisStateView, UncertainDeliveryAttempt, UndoDoneConflict, UndoDoneRefusal, UndoDoneResult,
  RequestTrashRefusal, RestoreRequestResult, TrashRequestResult, UserRow, TeamRow, TeamMemberRow,
  FeatureKey, QuotaKey, PlanQuotaKey, FeatureSource, OwnerTenantFeatureView, OwnerTenantFeatureQuota,
  OwnerPlanQuota, OwnerTenantFeatures, FeatureSettingValue, FeatureDefaults, GooglePlacesQuotaState, SetTenantFeatureInput,
  OwnerTenantRuleParameters, RuleParamKey, RuleParamValues, RuleParameterDefinition, RuleParameterIssue,
  UpdateTenantRuleParametersInput, OwnerRuleValueDelegation, UpdateRuleValueDelegationInput,
  RuleValueGrant, RuleValueDelegation, RuleDelegationIssue,
  BusinessRuleValues, UpdateBusinessRuleValuesInput, RuleValuePreview,
  SetPlanLimitsInput,
  CatalogArticleList, CatalogImportSummary, TenantCatalogStats,
  TestMailCatalog, TestMailInjectResult,
  TestMailEnquiryCategory, TestMailEnquiryOption, TestMailScenarioOption,
} from "./types";
